import { FormattedMessage } from "@react-intl";
import { NextPage } from "next";
import Link from "next/link";
import React from "react";

import { Button } from "@components/atoms";
import { paths } from "@paths";

import S from "./styles";

interface NotFoundProps {
  message?: string;
}

const NotFound: NextPage<NotFoundProps> = () => (
  <S.NotFound>
    <h2 className="header">
      <FormattedMessage defaultMessage="404" />
    </h2>
    <div className="ruler" />
    <div className="message">
      <p>
        <FormattedMessage defaultMessage="We can’t seem to find a page you are looking for!" />{" "}
      </p>
      <p>
        <FormattedMessage defaultMessage="You may have mistyped the address or the page may have moved." />{" "}
      </p>
      <p>
        <FormattedMessage defaultMessage="We’re sorry for the error and hope you’ll have a good day." />
      </p>
    </div>
    <div className="button">
      <Link href={paths.home}>
        <a>
          <Button testingContext="404pageGotoHomeButton">
            <FormattedMessage defaultMessage="Back to home" />
          </Button>
        </a>
      </Link>
    </div>
  </S.NotFound>
);

export default NotFound;
